<aside class="bg-(--bg-color) py-6">

    <!-- Header -->
    <div class="flex justify-between mb-3 md:mb-6">
        <p class="flex gap-2 text-generic">
            <img src="assets/icons/download-grey.svg" alt="download icon" />
            {{ 'TRANSACTIONS.DOWNLOAD_STATEMENT' | translate }}
        </p>
    </div>

    <!-- Toggle -->
    <div class="flex mx-auto justify-center items-center border border-[#DAE1E4] rounded-full p-1 w-full mb-8 text-generic">

        <span class="w-1/2 text-center rounded-full py-2 cursor-pointer" [ngClass]="{
              'bg-(--brand-primary) text-white': currentTab === 'month',
              'text-(--text-primary)': currentTab !== 'month'
          }" (click)="setTab('month')">
            {{ 'TRANSACTIONS.BY_MONTH' | translate }}
        </span>

        <span class="w-1/2 text-center rounded-full py-2 cursor-pointer" [ngClass]="{
              'bg-(--brand-primary) text-white': currentTab === 'date',
              'text-(--text-primary)': currentTab !== 'date'
          }" (click)="setTab('date')">
            {{ 'TRANSACTIONS.BY_DATE' | translate }}
        </span>

    </div>

    <!-- MONTH FORM -->
    <form *ngIf="currentTab === 'month'" [formGroup]="monthForm" class="space-y-8" (ngSubmit)="handleFormSubmission()">

        <app-date-picker label="{{'TRANSACTIONS.START_MONTH' | translate}}" defaultSelection="month" placeholder="{{'TRANSACTIONS.PLEASE_SELECT' | translate}}"
            [control]="getControl('startMonth', 'monthForm')" modalTitle="{{'TRANSACTIONS.SELECT_START_MONTH' | translate}}" [showInlineError]="true">
        </app-date-picker>

        <app-date-picker label="{{'TRANSACTIONS.END_MONTH' | translate}}" defaultSelection="month" placeholder="{{'TRANSACTIONS.PLEASE_SELECT' | translate}}" customClass="mt-6"
            [control]="getControl('endMonth', 'monthForm')" modalTitle="{{'TRANSACTIONS.SELECT_END_MONTH' | translate}}" [showInlineError]="true">
        </app-date-picker>

        <app-button text="{{ 'TRANSACTIONS.GENERATE_STATEMENT' | translate }}" type="submit" variant="primary" size="lg"
            extraClass="mt-6 w-full" [disabled]="monthForm.invalid">
        </app-button>

    </form>

    <!-- DATE FORM -->
    <form *ngIf="currentTab === 'date'" [formGroup]="dateForm" class="space-y-8" (ngSubmit)="handleFormSubmission()">

        <app-date-picker label="{{'TRANSACTIONS.START_DATE' | translate}}" placeholder="DD/MM/YYYY" [control]="getControl('startDate', 'dateForm')"
            modalTitle="{{'TRANSACTIONS.SELECT_START_DATE' | translate}}" [showInlineError]="true">
        </app-date-picker>

        <app-date-picker label="{{'TRANSACTIONS.END_DATE' | translate}}" placeholder="DD/MM/YYYY" [control]="getControl('endDate', 'dateForm')"
            customClass="mt-6" modalTitle="{{'TRANSACTIONS.SELECT_END_DATE' | translate}}" [showInlineError]="true">
        </app-date-picker>

        <app-button text="{{ 'TRANSACTIONS.GENERATE_STATEMENT' | translate }}" type="submit" variant="primary" size="lg"
            extraClass="mt-6 w-full" [disabled]="dateForm.invalid">
        </app-button>

    </form>

</aside>